interface Window {
    VideoBlockScriptInitialized: Boolean
}

let screen9InitializationInterval: number | undefined;

function createVideoBlock() {
    setVideoHeight();
    window.addEventListener("resize", setVideoHeight);

    // If marketing cookies are blocked by CookieBot
    if (!window.Cookiebot?.consent?.marketing || !window.screen9) {
        setVideoHeight();
        document.querySelectorAll(".video-block--video").forEach(blockElement => {
            blockElement.classList.add("video-block--prevent-video");

            blockElement.addEventListener("click", () => {
                blockElement.classList.add("video-block--show-video")
            });

            blockElement.addEventListener("keypress", (e: any) => {
                if (e.key === 'Enter') {
                    blockElement.classList.add("video-block--show-video")
                }
            });
        });
    }

    document.addEventListener('QuickChannelScriptLoaded', function (e) {
        if (window.Cookiebot.consent.marketing && !window.screen9) {
            window.QuickChannel.initialize();
            ensureVideoPlayersReady();
        } else if (window.Cookiebot.consent.marketing) {
            initializeVideoPlayers();
        }
    });

    // When CookieBot consents are changed
    window.addEventListener('CookiebotOnAccept', function (e) {
        document.dispatchEvent(new CustomEvent("QuickChannelRelatedScriptLoaded"));
    });

    // Tell other modules that this script is loaded
    document.dispatchEvent(new CustomEvent("QuickChannelRelatedScriptLoaded"));

    window.VideoBlockScriptInitialized = true;
}


// Add a video-player for every media block
function initializeMediaBlocks() {
    document.querySelectorAll(".video-block--video").forEach(blockElement => {
        blockElement.addEventListener("click", () => {
            initializeVideoAndPlay(blockElement);
        });

        blockElement.addEventListener("keypress", (e: any) => {
            if (e.key === 'Enter') {
                initializeVideoAndPlay(blockElement);
            }
        });
    });
}

function ensureVideoPlayersReady() {
    // Nothing to initialize (e.g. VideoBlock rendered without QuickChannelId)
    if (!document.querySelectorAll(".video-block--video").length) {
        return;
    }

    if (initializeVideoPlayers()) {
        return;
    }

    if (screen9InitializationInterval) {
        return;
    }

    let attempts = 0;
    const maxAttempts = 50; // ~10 seconds

    screen9InitializationInterval = window.setInterval(() => {
        attempts++;

        if (initializeVideoPlayers() && screen9InitializationInterval) {
            window.clearInterval(screen9InitializationInterval);
            screen9InitializationInterval = undefined;
        } else if (attempts >= maxAttempts && screen9InitializationInterval) {
            window.clearInterval(screen9InitializationInterval);
            screen9InitializationInterval = undefined;

            // Reset any blocks that were waiting for deferred playback
            document.querySelectorAll(".video-block--video").forEach(blockElement => {
                if (blockElement instanceof HTMLElement && blockElement.dataset.pendingPlay === "true") {
                    delete blockElement.dataset.pendingPlay;
                    blockElement.classList.remove("video-block--load-video");
                }
            });
        }
    }, 200);
}

function initializeVideoPlayers() {
    if (!window.screen9) {
        return false;
    }

    document.querySelectorAll(".video-block--video").forEach(blockElement => {
        if (blockElement instanceof HTMLElement) {
            const {mediaid, containerid} = blockElement.dataset;
            window.QuickChannel.createPlayer(mediaid, containerid, onPlayerStateChange);
            blockElement.classList.remove("video-block--prevent-video");

            if (blockElement.dataset.pendingPlay === "true") {
                if (window.QuickChannel.playVideo(blockElement)) {
                    delete blockElement.dataset.pendingPlay;
                } else {
                    blockElement.classList.remove("video-block--load-video");
                }
            } else {
                blockElement.classList.remove("video-block--show-video");
            }
        }
    });

    return true;
}

function initializeVideoAndPlay(blockElement: Element) {
    if (!(blockElement instanceof HTMLElement)) {
        return;
    }

    if (!window.Cookiebot?.consent?.marketing) {
        return;
    }

    blockElement.classList.remove("video-block--show-video");
    blockElement.classList.add("video-block--load-video");

    if (!window.screen9) {
        blockElement.dataset.pendingPlay = "true";

        if (window.Cookiebot?.consent?.marketing) {
            window.QuickChannel.initialize();
            ensureVideoPlayersReady();
        } else {
            blockElement.classList.remove("video-block--load-video");
        }

        return;
    }

    const {mediaid, containerid} = blockElement.dataset;
    window.QuickChannel.createPlayer(mediaid, containerid, onPlayerStateChange);

    if (!window.QuickChannel.playVideo(blockElement)) {
        blockElement.classList.remove("video-block--load-video");
    }
}

function setVideoHeight() {
    document.querySelectorAll(".video-block").forEach((block : HTMLElement | any) => {
        let blockMediaIcon = block.querySelector(".video-block__icon");

        const image = block.querySelector("img") as HTMLImageElement;

        loadImage(image).then((loadedImage) => {
            // Use timeout to let the layout transition finish first
            setTimeout(() => {
                if (block instanceof HTMLElement) {
                    let imgHeight = loadedImage.offsetHeight;

                    // Set video height, this will position the icon in the middle
                    let blockVideo = block.querySelector(".video-block__video");
                    if (blockVideo instanceof HTMLElement && !!imgHeight) {
                        blockVideo.style.height = `${imgHeight}px`;

                        // Show icon after video height is set
                        if (blockMediaIcon instanceof HTMLElement && !!imgHeight) {
                            blockMediaIcon.style.opacity = "1";
                        }
                    }
                }
            }, 100);
        })
    });
}
function loadImage(imageElement : HTMLImageElement) : Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        imageElement.onload = () => {
            resolve(imageElement);
        };

        if (imageElement.complete){
            resolve(imageElement);
        }

        imageElement.onerror = reject
    });
}

function onPlayerStateChange(event: any, containerId: string | undefined) {
    let blockElement = document.querySelector(`#${containerId}`)?.closest(".video-block");

    if (event == "pause") {
        blockElement?.classList.remove("video-block--show-video");
    } else if (event == "play") {
        blockElement?.classList.remove("video-block--load-video");
        blockElement?.classList.add("video-block--show-video");
    }
}


initializeMediaBlocks();


window.addEventListener('CookiebotOnLoad', () => {
    if (!window.window.VideoBlockScriptInitialized) {
        createVideoBlock();
    }
});
